<template>
  <div id="ModifyUserPhone">
    <el-dialog :center="true" title="手机号码修改" :visible.sync="dialogVisible" width="600px" @close="resetForm('updatePhoneForm')">
      <el-form :model="updatePhoneForm" :rules="rules" ref="updatePhoneForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原手机号码">
          <el-col :span="4">&nbsp;</el-col>
          <el-col :span="12">
            {{userPhone}}
          </el-col>
          <el-col :span="8">
            <div class="orange-btn">
              <ebSendCode :butId="oldButId" :params="oldParams" />
            </div>
          </el-col>
        </el-form-item>
        <el-form-item label="输入验证码" prop="verificationCodeOld">
          <el-col :span="16">
            <el-input class="eb-input" v-model="updatePhoneForm.verificationCodeOld" placeholder="输入验证码"></el-input>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
        </el-form-item>
        <el-form-item label="输入新手机" prop="newPhoneNumber">
          <el-col :span="16">
            <el-input class="eb-input" v-model="updatePhoneForm.newPhoneNumber" placeholder="输入新手机号码"></el-input>
          </el-col>
          <el-col :span="8">
            <div class="orange-btn">
              <ebSendCode :disabled="isDisabled" :butId="newButId" :params="newParams" />
            </div>
          </el-col>
        </el-form-item>
        <el-form-item label="输入验证码" prop="verificationCodeNew">
          <el-col :span="16">
            <el-input class="eb-input" v-model="updatePhoneForm.verificationCodeNew" placeholder="输入验证码"></el-input>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
        </el-form-item>
        <div class="eb-button-group">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm('updatePhoneForm')">关闭</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="editUserPhoneBtn('updatePhoneForm')">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { editUserPhone } from '@/services/user/user-service';
import ebSendCode from '@/components/common/eb-send-code';
export default {
  name: 'ModifyUserPhone',
  components: {
    ebSendCode
  },
  data() {
    let validateCode = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (!value) {
        callback(new Error('请输入手机验证码'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入6位数字手机验证码'));
      } else {
        callback();
      }
    };
    let checkUserPhone = (rule, value, callback) => {
      let reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
      if (!value) {
        this.isDisabled = true;
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        this.isDisabled = true;
        callback(new Error('请输入有效的手机号'));
      } else if (value === this.userPhone) {
        this.isDisabled = true;
        callback(new Error('两次输入的手机号相同，请重新输入'));
      } else {
        this.isDisabled = false;
        this.newParams.phoneNumber = value;
        callback();
      }
    };
    return {
      dialogVisible: false,
      userPhone: '',
      oldButId: 'modifyPhoneOld',
      oldParams: {
        phoneNumber: '',
        verificationCodeType: 'verification_code_old'
      },
      newButId: 'modifyPhoneNew',
      newParams: {
        phoneNumber: '',
        verificationCodeType: 'verification_code_new'
      },
      isDisabled: true,
      updatePhoneForm: {
        verificationCodeOld: '',
        newPhoneNumber: '',
        verificationCodeNew: ''
      },
      rules: {
        verificationCodeOld: [{ required: true, validator: validateCode, trigger: 'blur' }],
        newPhoneNumber: [{ required: true, validator: checkUserPhone, trigger: 'blur' }],
        verificationCodeNew: [{ required: true, validator: validateCode, trigger: 'blur' }]
      }
    };
  },
  created() {
    eventBus.$on('modifyUserPhone', userPhone => {
      this.dialogVisible = true;
      this.userPhone = userPhone;
      this.oldParams.phoneNumber = userPhone;
    });
  },
  methods: {
    editUserPhoneBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editUserPhone();
        } else {
          return false;
        }
      });
    },
    async editUserPhone() {
      var params = {
        oldPhoneNumber: this.userPhone,
        verificationCodeOld: this.updatePhoneForm.verificationCodeOld,
        newPhoneNumber: this.updatePhoneForm.newPhoneNumber,
        verificationCodeNew: this.updatePhoneForm.verificationCodeNew
      };
      try {
        let { data } = await editUserPhone(params);
        if (data.returnCode === '01') {
          this.$message.success('更新手机号成功！');
          eventBus.$emit('modifyUserPhoneSucess', this.updatePhoneForm.newPhoneNumber);
          this.dialogVisible = false;
        } else if (data.returnCode === '05') {
          if (data.errorCode === '01') {
            this.$message.error('原手机验证码错误！');
          } else if (data.errorCode === '02') {
            this.$message.error('新手机验证码错误！');
          } else {
            this.$message.error('验证码已过期！');
          }
        } else {
          if (data.errorCode === '03') {
            this.$message.error('填写的手机号在系统中已存在，请检查！');
          } else {
            this.$message.error('更新手机号失败！');
          }
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    resetForm: function(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    }
  },
  beforeDestroy() {
    eventBus.$off('modifyUserPhone');
  }
};
</script>
<style scoped lang="less">
#ModifyUserPhone {
  .orange-btn {
    height: 30px;
    width: 120px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    float: right;
  }
}
</style>
